import React, { useEffect } from "react";
import Spinner, { styles } from "components/Spinner";
import { gotoUrl, pathWithChannel } from "utils/helpers";
import { publicPaths, DEFAULT_CHANNEL } from "utils/constants";

const AuLostServiceRedirection = () => {
  /**
   * redirect au user to select-email route continue the otp flow
   */
  useEffect(() => {
    gotoUrl(pathWithChannel(publicPaths.SELECT_EMAIL, DEFAULT_CHANNEL));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Spinner size={200} sx={styles.fullPage} />;
};
export default AuLostServiceRedirection;
